module.exports = __webpack_public_path__ + "56e68f3bd0080b4e260022d2e307d79f.jpg";